import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentCSSStyle } from '../../uicomponentcss';
import { MsisdnTextComponent } from './msisdntextcomponent';
import { SpecialCallerCSSStyleImpl } from './specialcallercss';

export class SpecialCallerTextComponent extends MsisdnTextComponent
{
    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SpecialCallerCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/msisdntext/specialcallertextcomponent.tsx